export type GameCardEditorMode = "form" | "code";
export type GameCardEditorCodeFormat = "json" | "rqt";
export type GameCardEditorRqtSourceStatus = "current" | "stale";

export interface NextGameCardExtensionsForEditorSaveOptions {
  rqtSourceStatus?: GameCardEditorRqtSourceStatus;
}

export function isSourceRqtCurrent(extensions: Record<string, unknown> | undefined): boolean {
  return currentSourceRqt(extensions) !== undefined;
}

export function currentSourceRqt(extensions: Record<string, unknown> | undefined): string | undefined {
  if (extensions?.["sourceRqtStatus"] !== "current") return undefined;
  const source = extensions["sourceRqt"];
  if (typeof source !== "string") return undefined;
  return source.trim() ? source : undefined;
}

export function nextGameCardExtensionsForEditorSave(
  existing: Record<string, unknown> | undefined,
  mode: GameCardEditorMode,
  codeFormat: GameCardEditorCodeFormat,
  codeText: string,
  options: NextGameCardExtensionsForEditorSaveOptions = {},
): Record<string, unknown> | undefined {
  const extensions: Record<string, unknown> = { ...(existing ?? {}) };
  const officialSampleId = typeof extensions["officialRqtSampleId"] === "string"
    ? extensions["officialRqtSampleId"]
    : undefined;
  const basedOnSampleId = typeof extensions["basedOnOfficialRqtSampleId"] === "string"
    ? extensions["basedOnOfficialRqtSampleId"]
    : undefined;
  const sampleId = basedOnSampleId ?? officialSampleId;
  if (officialSampleId || extensions["sourceKind"] === "official-sample") {
    delete extensions["officialRqtSampleId"];
    delete extensions["officialRqtSampleFilename"];
    delete extensions["officialRqtSampleSourcePath"];
    extensions["sourceKind"] = "based-on-official-sample";
    if (sampleId) extensions["basedOnOfficialRqtSampleId"] = sampleId;
  }
  if (mode === "code" && codeFormat === "rqt" && options.rqtSourceStatus === "current") {
    extensions["sourceRqt"] = codeText;
    extensions["sourceRqtStatus"] = "current";
  } else if (typeof extensions["sourceRqt"] === "string") {
    extensions["sourceRqtStatus"] = "stale";
  }
  return Object.keys(extensions).length ? extensions : undefined;
}
